import { NhpLandingCalculator } from "@component/Nhp/LandingCalculator/NhpLandingCalculator";
import { NhpSmallCalculator } from "@component/Nhp/SmallCalculator/NhpSmallCalculator";
import {
	faArrowRight as fasArrowRight,
	faCalculator as fasCalculator,
} from "@awesome.me/kit-3777c2145e/icons/classic/solid";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { LandingAccordion } from "@landing/components/LandingAccordion";
import { GoogleAnalytics4 } from "@utils/google-analytics-4";
import { Button, LandingContainer, List } from "bm-ui-kit";
import React from "react";
import type { ReactNode } from "react";
import { Accordion, Alert, Col, Row } from "react-bootstrap";
import "./novekedesi-hitel.scss";

/**
 * @Routing
 *
 * @title "NHP Hajrá Kalkulátor [YEAR]: olcsó céges hitel a válságban!"
 * @description "NHP Hajrá hitelcélok: beruházásra, forgóeszköz (vevő, készlet, munkabér) finanszírozásra, cégfelvásárlásra , vagy akár hitelkiváltásra!"
 * @route "/vallalati/hitel/novekedesi-hitel/"
 */
export default class Landing extends React.PureComponent {
	public render(): ReactNode {
		return (
			<>
				<LandingContainer bgClassName="bg-trianglify-blue bg-border-bottom" bgColor="#1d9bbe" size="lg">
					<Row className="d-flex align-items-top">
						<Col md={6} className="text-white">
							<h1>
								<span className="display-1 display-bold">
									NHP HAJRÁ: KEDVEZMÉNYES VÁLLALKOZÓI HITEL A VÁLSÁGBAN!
								</span>
							</h1>
							<Alert variant="warning">
								<p>
									<strong>NHP Hajrá!</strong> konstrukció <strong>keretösszege kimerült</strong>, a
									termék <strong>nem elérhető!</strong>
								</p>
								<p>
									Jelenleg legkedvezőbb és legszélesebb körben támogatott hitel (max. 0,5%
									kamatozással, 500.000 - 1 milliárd Ft) <br /> a Széchenyi GO!
								</p>
								<Button
									href="/vallalati/hitel/szechenyi-hitel/?link_type=landing-button"
									variant="success"
									icon={<FontAwesomeIcon icon={fasArrowRight} />}
								>
									Tovább a részletekre
								</Button>
							</Alert>
							<List itemStyle="tick">
								<List.Item>
									Hitelösszeg: <strong>1 millió Ft-tól 20 milliárd Ft-ig</strong>
								</List.Item>
								<List.Item>
									<strong>Hitelcélok széles körére:</strong> beruházásra, forgóeszköz (vevő, készlet,
									munkabér) finanszírozásra, cégfelvásárlásra , vagy akár hitelkiváltásra
								</List.Item>
								<List.Item>
									<strong>Maximális futamidő 20 évre</strong> nőtt
								</List.Item>
								<List.Item>
									<strong>Kamat: maximum 2,5% (fix)</strong> -&gt; az MNB 4%-os kamattámogatása miatt
									akár <strong>ennél lényegesen kedvezőbb is lehet</strong>
								</List.Item>
								<List.Item>
									Legalább <strong>egy teljes lezárt évvel rendelkező vállalkozásoknak</strong>
								</List.Item>
								<List.Item>
									<strong>Több banknál elérhető</strong>, DE eltérő fedezet és eltérő hitelösszeg
									mellett
								</List.Item>
							</List>
						</Col>
						<Col id="nhp-fix-small" md={6} className="px-0 px-sm-3">
							<NhpSmallCalculator outsideTitle={null} outsideTitleLink={null} />
						</Col>
					</Row>
				</LandingContainer>
				<LandingContainer size="lg">
					<Row>
						<Col xs={12} md={4}>
							<p className="text-center">
								<span className="blue-bold">1 millió - 20 milliárd Ft</span> igényelhető hitelösszeg
							</p>
						</Col>
						<Col xs={12} md={4}>
							<p className="text-center">
								<span className="blue-bold">2,5%</span> maximális hitelkamat
							</p>
						</Col>
						<Col xs={12} md={4}>
							<p className="text-center">
								<span className="blue-bold">Akár 20 év</span> maximális futamidő
							</p>
						</Col>
					</Row>
				</LandingContainer>
				<div id="nhp-fix-landing-simple-calc">
					<LandingContainer size="lg">
						<Row className="d-flex align-items-center justify-content-center">
							<Col xs={12}>
								<span className="h1 mb-lg-4 mb-md-3 mb-2 text-center">
									Fizetési kötelezettség növekedési hitel felvételét követően
								</span>
							</Col>
							<Col xs={12} sm={8} md={6} lg={5} xl={4} className="px-1 px-sm-3 mt-3">
								<span className="table-title mb-2">
									Havi visszafizetés a futamidő
									<br /> függvényében
								</span>
								<NhpLandingCalculator />
							</Col>
							<Col xs={12} xl={8}>
								<List itemStyle="square">
									<List.Item>
										<strong>2,5%, azaz a legmagasabb hitelkamatszint</strong> esetén a hitelfelvevő
										a banknak havonta azonos tőketörlesztést fizet, a kamat pedig az aktuális
										tőketartozásra kerül felszámításra, ebből az következik, hogy a hitelterhek
										(tőke+kamatfizetés együtt) <strong>folyamatosan csökkennek</strong> a{" "}
										<strong>futamidő alatt</strong>
									</List.Item>
									<List.Item>
										a fenti táblázat a <strong>legmagasabb</strong>, azaz a futamidő elején érvényes
										törlesztőrészletet mutatja
									</List.Item>
									<List.Item>
										<strong>havi hiteltörlesztés</strong> helyett{" "}
										<strong>negyedéves hiteltörlesztés</strong> is választható bizonyos esetekben
									</List.Item>
								</List>
							</Col>
						</Row>
					</LandingContainer>
				</div>
				<LandingContainer id="nhp-fix-landing-bm-content" size="lg">
					<Row className="justify-content-center">
						<Col xs={12} md={10} lg={8}>
							<h2 className="h1 mb-lg-4 mb-md-3 mb-2 text-center"> A Bankmonitor segít!</h2>
							<List itemStyle="tick" variant="secondary">
								<List.Item>
									<strong>Átvizsgáljuk</strong>, hogy céged jellemzői alapján, mely bankok nyújthatják{" "}
									<strong>legkedvezőbb feltételekkel az NHP-t.</strong>
								</List.Item>
								<List.Item>
									<strong>Megversenyeztetjük a bankokat</strong>, így kamatban és fedezeti elvárásban
									is <strong>optimális megoldáshoz</strong> juttatjuk cégedet
								</List.Item>
								<List.Item>
									Megvizsgáljuk a <strong>beruházáshoz</strong> (és így a hitelfelvételhez) kapcsolódó{" "}
									<strong>pénzügyi tervet</strong>, kérésed esetén elkészítjük azt
								</List.Item>
								<List.Item>
									<strong>Számszerűsítjük</strong>, hogy milyen havi{" "}
									<strong>törlesztőrészlettel</strong> számolhatsz
								</List.Item>
								<List.Item>
									<strong>Véleményezzük a hitelszerződést</strong> és megmutatjuk, hogyan érhetsz el{" "}
									<strong>kedvezőbb szerződést</strong>
								</List.Item>
							</List>
							<div className="text-center">
								<Button
									href="#nhp-fix-small"
									variant="gold"
									size="lg"
									onClick={() =>
										GoogleAnalytics4.sendEvent("BM_scrollTo", {
											buttonName: "toCalculator1",
										})
									}
								>
									<FontAwesomeIcon icon={fasCalculator} className="mr-2" />
									Ugrás a kalkulátorra
								</Button>
							</div>
						</Col>
					</Row>
				</LandingContainer>
				<div id="nhp-fix-landing-q-and-a" className="py-5">
					<LandingContainer>
						<Row className="justify-content-center">
							<Col xs={12} md={10} lg={8}>
								<h2 className="h1 mb-lg-4 mb-md-3 mb-2 text-center">
									Milyen konkrét hitelcélokra érhető el az NHP Hajrá?{" "}
								</h2>
								<strong>1. Eszközök, berendezések vásárlása, felújítása, kapacitás fejlesztése:</strong>
								<List itemStyle="square">
									<List.Item>
										Minden közvetlenül a működést szolgáló eszköz, munkagép, berendezés
									</List.Item>
								</List>
								<strong>2. Ingatlan vásárlás, fejlesztés, felújítás:</strong>
								<List itemStyle="square">
									<List.Item>
										Lakóingatlan, üdülő, szálloda: ha a fő tevékenység szálláshely szolgáltatás
										(szálloda, panzió, apartman, munkásszálló)
									</List.Item>
									<List.Item>
										Üzleti ingatlanok: csak üzletszerű használatra, tovább értékesítés, bérbeadás
										céljából nem (iroda, telephely, raktár, bemutató terem)
									</List.Item>
								</List>
								<strong>3. Használt és új személygépkocsi vásárlás (lízing és hitel formában):</strong>
								<List itemStyle="square">
									<List.Item>
										Csak fő tevékenységben személyszállítással foglalkozó cégek részére - taxi
										társaságoknak
									</List.Item>
								</List>
								<strong>4. Használt és új haszongépjármű vásárlás (lízing és hitel formában)</strong>
								<br />
								<strong>5. Forgóeszköz finanszírozás:</strong>
								<List itemStyle="square">
									<List.Item>akár munkabér finanszírozásra is</List.Item>
								</List>
								<strong>6. Hitelkiváltás:</strong>
								<List itemStyle="square">
									<List.Item>
										korábbi kedvezőtlenebb feltétellel bíró hiteleink futamidejének
										meghosszabbítására, alacsonyabb kamatozás elérésére
									</List.Item>
								</List>
								<strong>7. Cégfelvásárlás finanszírozására</strong>
							</Col>
						</Row>
					</LandingContainer>
				</div>
				<div id="nhp-fix-landing-q-and-a-2" className="py-5">
					<LandingContainer>
						<Row className="justify-content-center">
							<Col xs={12} md={10} lg={8}>
								<h2 className="h1 mb-lg-4 mb-md-3 mb-2 text-center">Ki kaphat NHP hitelt?</h2>
								az alábbi elvárásoknak kell megfelelnie a Növekedési Hitelt igénylő vállalkozásoknak
								<List itemStyle="square">
									<List.Item>
										<strong>cégforma: Kft, Nyrt, Zrt, Bt, egyéni vállalkozó</strong>
									</List.Item>
									<List.Item>
										<strong>
											működési múlt: min. egy teljes (jan. 1. -dec. 31.) lezárt üzleti év{" "}
										</strong>
									</List.Item>
									<List.Item>
										<strong>
											tulajdonosi háttér: az elmúlt 6 hónapban nem volt 50%-nál nagyobb
											tulajdonosi változás
										</strong>
									</List.Item>
									<List.Item>
										<strong>pénzügyi háttér:</strong>
										<div className="sub-text">
											- pozitív saját tőke
											<br />- nyereséges gazdálkodás
										</div>
									</List.Item>
									<List.Item>
										<strong>legfőbb kizáró okok: </strong>
										<div className="sub-text">
											- NAV végrehajtás
											<br />- korábbi kifizetetlen bankhitel
											<br />- tulajdonos KHR/BAR listán szerepel
										</div>
									</List.Item>
								</List>
								<div className="text-center">
									<Button
										href="#nhp-fix-small"
										variant="gold"
										size="lg"
										onClick={() =>
											GoogleAnalytics4.sendEvent("BM_scrollTo", {
												buttonName: "toCalculator2",
											})
										}
									>
										<FontAwesomeIcon icon={fasCalculator} className="mr-2" />
										Ugrás a kalkulátorra
									</Button>
								</div>
							</Col>
						</Row>
					</LandingContainer>
				</div>
				<div className="bg-trianglify-blue bg-border-y">
					<p className="blue-stripe-text py-3">Lendítsd fel vállalkozásod, NÖVEKEDÉSI HITEL PROGRAMMAL!</p>
				</div>
				<div id="nhp-fix-landing-faq" className="py-5">
					<LandingContainer>
						<Row className="justify-content-center">
							<Col xs={12} lg={10}>
								<Accordion id="accordionNHP">
									<LandingAccordion title="Mi az a Növekedési Hitel Program Hajrá (NHP Hajrá)?">
										<List itemStyle="square">
											<List.Item>
												A Magyar Nemzeti Bank a kereskedelmi bankoknak + 1.000 milliárd Ft
												keretösszeget biztosít vállalatok, vállalkozások számára történő
												hitelkihelyezésre
											</List.Item>
											<List.Item>
												Az NHP több különböző formában volt elérhető az elmúlt években, jelenleg
												kizárólag beruházási célokra vehetik fel a vállalkozások
											</List.Item>
											<List.Item>
												Az MNB +4%-os kamattámogatást biztosít a bankok részére a kihelyezett
												összegek után, ami lehetővé teszi számukra a maximális fix 2,5%-os
												kamatmérték csökkentését, akár negatív kamatozásig is
											</List.Item>
											<List.Item>
												A hitelminősítést (azaz ki és milyen feltétellel kaphat hitelt) az egyes
												kereskedelmi bankok végzik, így NHP hitelt igényelni kizárólag
												kereskedelmi bankoktól lehetséges - A hitelezés kockázatát a bankok
												viselik (akkor is vissza kell fizetniük az MNB-nek a kihelyezett
												összeget, ha a hitelfelvevő csődbe megy), így a normál piaci hiteleknél
												megszokott módon az egyes bankok hitelminősítése (ki és mennyi hitelt
												kaphat) jelentősen eltér
											</List.Item>
										</List>
									</LandingAccordion>
									<LandingAccordion title="Milyen gyorsan juthatok NHP hitelhez?">
										<p>
											Az MNB a bankok döntési idejét 2 hétben maximalizálja, amennyiben a
											döntéshez szükséges minden dokumentumot az ügyfél rendelkezésre bocsátott, a
											bankoknak ennyi időn belül meg kell hozniuk a döntésüket
										</p>
									</LandingAccordion>
									<LandingAccordion title="Milyen költségekre lehet számítani?">
										<p>
											<strong>Kamat:</strong> maximum 2,5% / év. A hitelkamat 2,5% alá
											csökkenthető a jelentős profitabilitást felmutató cégek számára. (Ebben is
											segít a Bankmonitor)
											<br />
											<strong>Hitelbírálati díj és egyéb kezdeti költségek:</strong> nincs ilyen
											költség
											<br />
											<strong>A hitel előtörlesztési költsége:</strong> nincs, ingyenesen bármikor
											előtörleszthető részlegesen, vagy teljesen
											<br />
											<strong>Hitelgarancia díja:</strong> külön fizetendő, amennyiben a Garantiqa
											kezességvállalását kéri a bank (jellemzően a hitelösszeg 1,3-1,4%/év)
										</p>
									</LandingAccordion>
								</Accordion>
							</Col>
						</Row>
					</LandingContainer>
				</div>
				<div className="bg-trianglify-blue bg-border-y py-4">
					<LandingContainer className="text-center">
						<span className="h2 text-white">NÉZD MEG, HOGY KAPHATSZ-E NHP HITELT!</span>
						<div className="text-center mt-3">
							<Button
								href="#nhp-fix-small"
								variant="gold"
								size="lg"
								onClick={() =>
									GoogleAnalytics4.sendEvent("BM_scrollTo", {
										buttonName: "toCalculator3",
									})
								}
							>
								<FontAwesomeIcon icon={fasCalculator} className="mr-2" />
								Ugrás a kalkulátorra
							</Button>
						</div>
					</LandingContainer>
				</div>
				<div id="nhp-fix-landing-steps" className="pb-5">
					<LandingContainer className="text-center">
						<div className="step-holder">
							<div className="stripe-1 mt-4" />
							<h2 className="h1 mb-lg-4 mb-md-3 mb-2 text-center">
								A <strong>BANKMONITOR</strong> <br />
								INGYEN SEGÍT!
							</h2>
							<div className="stripe-2" />
							<div className="number-block">
								<span className="number">1</span>
								<p className="small">
									Értünk a vállalati / vállalkozói hitelezéshez. Csapatunk
									<br />
									tagja között megtalálható hitelkockázat-elemző,
									<br />
									hitelbíráló, vállalati hiteltermék fejlesztő kolléga is.
								</p>
							</div>
							<div className="stripe-3" />
							<div className="number-block">
								<span className="number">2</span>
								<p className="small">
									Évente több milliárd forint értékű finanszírozáshoz
									<br /> segítjük hozzá a magyar cégtulajdonosokat.
								</p>
							</div>
							<div className="stripe-3" />
							<div className="number-block">
								<span className="number">3</span>
								<p className="small">
									A legegyszerűbb esetektől a legkomplexebb esetekig
									<br />a legjobb, a tulajdonos számára élhető megoldás
									<br />
									elérésén dolgozunk.
								</p>
							</div>
							<div className="stripe-3" />
							<div className="number-block">
								<span className="number">4</span>
								<p className="small">
									A legkisebb és a legnagyobb bankok hitelezési
									<br /> gyakorlatát is jól ismerjük.
								</p>
							</div>
							<div className="stripe-3" />
							<div className="number-block">
								<span className="number">5</span>
								<p className="small">
									Siker orientáltak vagyunk (és számunkra a siker a<br /> cégtulajdonos számára
									biztosított
									<br />
									optimális hitelmegoldás)
								</p>
							</div>
							<Button
								variant="gold"
								size="lg"
								icon={<FontAwesomeIcon icon={fasCalculator} />}
								href="#nhp-fix-small"
								className="mt-5"
								onClick={() =>
									GoogleAnalytics4.sendEvent("BM_scrollTo", {
										buttonName: "toCalculator4",
									})
								}
							>
								Ugrás a kalkulátorra
							</Button>
						</div>
					</LandingContainer>
				</div>
			</>
		);
	}
}
